import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { defineMessages, injectIntl } from "react-intl";
import Select from "react-select";
import ProposalMergeFields from "../../template/MergeFields.jsx";
import Icon from "../icon/icon.component.jsx";

const uuidv4 = require('uuid/v4')


const messages = defineMessages({
    first_name_label: {
        id: 'common.rich_text.merge_fields.first_name_label',
        defaultMessage: 'Contact first name',
    },
    captured_at_label: {
        id: 'common.rich_text.merge_fields.captured_at_label',
        defaultMessage: 'Captured at',
    },
    last_name_label: {
        id: 'common.rich_text.merge_fields.last_name_label',
        defaultMessage: 'Contact last name',
    },
    name_label: {
        id: 'common.rich_text.merge_fields.name_label',
        defaultMessage: 'Contact full name',
    },
    street_label: {
        id: 'common.rich_text.merge_fields.street_label',
        defaultMessage: 'Contact street',
    },
    city_label: {
        id: 'common.rich_text.merge_fields.city_label',
        defaultMessage: 'Contact city',
    },
    postal_code_label: {
        id: 'common.rich_text.merge_fields.postal_code_label',
        defaultMessage: 'Contact postal code',
    },
    country_label: {
        id: 'common.rich_text.merge_fields.country_label',
        defaultMessage: 'Contact country',
    },
    state_label: {
        id: 'common.rich_text.merge_fields.state_label',
        defaultMessage: 'Contact state',
    },
    total_amount_label: {
        id: 'common.rich_text.merge_fields.total_amount_label',
        defaultMessage: 'Total amount',
    },
    total_amount_without_tax_label: {
        id: 'common.rich_text.merge_fields.total_amount_without_tax_label',
        defaultMessage: 'Total amount without tax',
    },
    project_title_label: {
        id: 'common.rich_text.merge_fields.project_title_label',
        defaultMessage: 'Project title',
    },
    deposit_amount_label: {
        id: 'common.rich_text.merge_fields.deposit_amount_label',
        defaultMessage: 'Deposit amount',
    },
    deposit_ratio_label: {
        id: 'common.rich_text.merge_fields.deposit_ratio_label',
        defaultMessage: 'Deposit ratio (%)',
    },
    remaining_balance_label: {
        id: 'common.rich_text.merge_fields.remaining_balance_label',
        defaultMessage: 'Invoice - Remaining balance to pay',
    },
    paid_amount_label: {
        id: 'common.rich_text.merge_fields.paid_amount_label',
        defaultMessage: 'Invoice - Paid amount',
    },
    contact_tax_number: {
        id: 'common.rich_text.merge_fields.contact_tax_number_label',
        defaultMessage: 'Contact Tax number',
    },
    account_tax_number: {
        id: 'common.rich_text.merge_fields.account_tax_number_label',
        defaultMessage: 'Account Tax number',
    },
    state_code_label: {
        id: 'common.rich_text.merge_fields.state_code_label',
        defaultMessage: 'Contact state code',
    },
    organization_name_label: {
        id: 'common.rich_text.merge_fields.organization_name_label',
        defaultMessage: 'Contact organization name',
    },
    email_label: {
        id: 'common.rich_text.merge_fields.email_label',
        defaultMessage: 'Contact email',
    },
    phone_number_label: {
        id: 'common.rich_text.merge_fields.phone_number_label',
        defaultMessage: 'Contact phone number',
    },
    grand_total_discount_amount_label: {
        id: 'common.rich_text.merge_fields.grand_total_discount_amount_label',
        defaultMessage: 'Discount grand total amount',
    },
    grand_total_discount_ratio_label: {
        id: 'common.rich_text.merge_fields.grand_total_discount_ratio_label',
        defaultMessage: 'Discount grand total percent',
    },
    discount_amount_label: {
        id: 'common.rich_text.merge_fields.discount_amount_label',
        defaultMessage: 'Discount global amount',
    },
    discount_percent_label: {
        id: 'common.rich_text.merge_fields.discount_percent_label',
        defaultMessage: 'Discount global percent',
    },
    due_date_label: {
        id: 'common.rich_text.merge_fields.due_date_label',
        defaultMessage: 'Invoice due date',
    },
    date_label: {
        id: 'common.rich_text.merge_fields.date_label',
        defaultMessage: 'Document effective date',
    },
    lightspeed_external_id_label: {
        id: 'common.rich_text.merge_fields.lightspeed_external_id_label',
        defaultMessage: 'Lightspeed sale ID',
    },
    lightspeed_workorder_id_label: {
        id: 'common.rich_text.merge_fields.lightspeed_workorder_id_label',
        defaultMessage: 'Lightspeed workorder ID',
    },
    reference_label: {
        id: 'common.rich_text.merge_fields.reference_label',
        defaultMessage: 'Document reference ID',
    },
    pdf_url_label: {
        id: 'common.rich_text.merge_fields.pdf_url_label',
        defaultMessage: 'Document PDF link',
    },
    ship_to_first_name_label: {
        id: 'common.rich_text.merge_fields.ship_to_first_name_label',
        defaultMessage: 'Shipping contact first name',
    },
    ship_to_last_name_label: {
        id: 'common.rich_text.merge_fields.ship_to_last_name_label',
        defaultMessage: 'Shipping contact last name',
    },
    ship_to_name_label: {
        id: 'common.rich_text.merge_fields.ship_to_name_label',
        defaultMessage: 'Shipping contact full name',
    },
    ship_to_street_label: {
        id: 'common.rich_text.merge_fields.ship_to_street_label',
        defaultMessage: 'Shipping contact street',
    },
    ship_to_city_label: {
        id: 'common.rich_text.merge_fields.ship_to_city_label',
        defaultMessage: 'Shipping contact city',
    },
    ship_to_postal_code_label: {
        id: 'common.rich_text.merge_fields.ship_to_postal_code_label',
        defaultMessage: 'Shipping contact postal code / zip',
    },
    ship_to_country_label: {
        id: 'common.rich_text.merge_fields.ship_to_country_label',
        defaultMessage: 'Shipping contact country',
    },
    ship_to_state_label: {
        id: 'common.rich_text.merge_fields.ship_to_state_label',
        defaultMessage: 'Shipping contact state',
    },
    ship_to_state_code_label: {
        id: 'common.rich_text.merge_fields.ship_to_state_code_label',
        defaultMessage: 'Shipping contact state code',
    },
    ship_to_organization_name_label: {
        id: 'common.rich_text.merge_fields.ship_to_organization_name_label',
        defaultMessage: 'Shipping contact organization name',
    },
    ship_to_phone_number_label: {
        id: 'common.rich_text.merge_fields.ship_to_phone_number_label',
        defaultMessage: 'Shipping contact phone number',
    },
    seller_name_label: {
        id: 'common.rich_text.merge_fields.seller_name_label',
        defaultMessage: 'Seller name',
    },
    seller_email_label: {
        id: 'common.rich_text.merge_fields.seller_email_label',
        defaultMessage: 'Seller email',
    },
    company_name_label: {
        id: 'common.rich_text.merge_fields.company_name_label',
        defaultMessage: 'Your company name',
    },
    company_phone_number_label: {
        id: 'common.rich_text.merge_fields.company_phone_number_label',
        defaultMessage: 'Your company phone number',
    },
    company_email_label: {
        id: 'common.rich_text.merge_fields.company_email_label',
        defaultMessage: 'Your company email',
    },
    company_street_label: {
        id: 'common.rich_text.merge_fields.company_street_label',
        defaultMessage: 'Your company street',
    },
    company_city_label: {
        id: 'common.rich_text.merge_fields.company_city_label',
        defaultMessage: 'Your company city',
    },
    company_state_label: {
        id: 'common.rich_text.merge_fields.company_state_label',
        defaultMessage: 'Your company state',
    },
    company_state_code_label: {
        id: 'common.rich_text.merge_fields.company_state_code_label',
        defaultMessage: 'Your company state code',
    },
    company_country_label: {
        id: 'common.rich_text.merge_fields.company_country_label',
        defaultMessage: 'Your company country',
    },
    company_postal_code_label: {
        id: 'common.rich_text.merge_fields.company_postal_code_label',
        defaultMessage: 'Your company postal code / zip',
    },
    po_number_label: {
        id: 'common.rich_text.merge_fields.po_number_label',
        defaultMessage: 'PO Number',
    },
    document_identifier_label: {
        id: 'common.rich_text.merge_fields.document_identifier_label',
        defaultMessage: 'The identifier of the document',
    },
    quote_expiration_date_label: {
        id: 'common.rich_text.merge_fields.quote_expiration_date_label',
        defaultMessage: 'Quote expiration date',
    },

    line_tax_amount_label: {
        id: 'common.rich_text.merge_fields.line_tax_amount_label',
        defaultMessage: 'Sales line - Tax amount',
    },
    line_subtotal_amount_label: {
        id: 'common.rich_text.merge_fields.line_subtotal_amount_label',
        defaultMessage: 'Sales line - Subtotal (without tax)',
    },
    line_subtotal_inclusive_amount_label: {
        id: 'common.rich_text.merge_fields.line_subtotal_inclusive_amount_label',
        defaultMessage: 'Sales line - Subtotal (tax inclusive)',
    },
    line_subtotal_amount_with_discount_label: {
        id: 'common.rich_text.merge_fields.line_subtotal_amount_with_discount_label',
        defaultMessage: 'Sales line - Subtotal with line discount',
    },
    line_subtotal_amount_with_global_discount_label: {
        id: 'common.rich_text.merge_fields.line_subtotal_amount_with_global_discount_label',
        defaultMessage: 'Sales line - Subtotal with line and global discount',
    },
    line_total_amount_label: {
        id: 'common.rich_text.merge_fields.line_total_amount_label',
        defaultMessage: 'Sales line - Total',
    },
    line_total_discount_amount_label: {
        id: 'common.rich_text.merge_fields.line_total_discount_amount_label',
        defaultMessage: 'Sales line - Total discount amount',
    },
    line_total_discount_amount_percentage_label: {
        id: 'common.rich_text.merge_fields.line_total_discount_amount_percentage_label',
        defaultMessage: 'Sales line - Total discount percentage',
    },
    line_unit_price_label: {
        id: 'common.rich_text.merge_fields.line_unit_price_label',
        defaultMessage: 'Sales line - Unit price (without tax)',
    },
    line_unit_price_after_discount_label: {
        id: 'common.rich_text.merge_fields.line_unit_price_after_discount_label',
        defaultMessage: 'Sales line - Unit price (net)',
    },
    line_unit_price_inclusive_label: {
        id: 'common.rich_text.merge_fields.line_unit_price_inclusive_label',
        defaultMessage: 'Sales line - Unit price (tax inclusive)',
    },
    line_item_title_label: {
        id: 'common.rich_text.merge_fields.line_item_title_label',
        defaultMessage: 'Sales line - Title',
    },
    line_item_measure_label: {
        id: 'common.rich_text.merge_fields.line_item_measure_label',
        defaultMessage: 'Sales line - Quantity',
    },
    line_item_sku_label: {
        id: 'common.rich_text.merge_fields.line_item_sku_label',
        defaultMessage: 'Sales line - SKU',
    },
    line_item_manufacturer_sku_label: {
        id: 'common.rich_text.merge_fields.line_item_manufacturer_sku_label',
        defaultMessage: 'Sales line - Manufacturer SKU',
    },
    line_item_manufacturers_label: {
        id: 'common.rich_text.merge_fields.line_item_manufacturers_label',
        defaultMessage: 'Sales line - Manufacturers',
    },
    line_item_short_description_label: {
        id: 'common.rich_text.merge_fields.line_item_short_description_label',
        defaultMessage: 'Sales line - Short description',
    },
    line_item_long_description_label: {
        id: 'common.rich_text.merge_fields.line_item_long_description_label',
        defaultMessage: 'Sales line - Long description',
    },
    line_item_tax_name_label: {
        id: 'common.rich_text.merge_fields.line_item_tax_name_label',
        defaultMessage: 'Sales line - Tax name',
    },
    line_item_total_tax_rate_label: {
        id: 'common.rich_text.merge_fields.line_item_total_tax_rate_label',
        defaultMessage: 'Sales line - Total tax rate',
    },
    line_item_inventory_requested_label: {
        id: 'common.rich_text.merge_fields.line_item_inventory_requested_label',
        defaultMessage: 'Sales line - Inventory requested',
    },
    line_item_inventory_received_label: {
        id: 'common.rich_text.merge_fields.line_item_inventory_received_label',
        defaultMessage: 'Sales line - Inventory received',
    },
    line_item_inventory_reserved_label: {
        id: 'common.rich_text.merge_fields.line_item_inventory_reserved_label',
        defaultMessage: 'Sales line - Inventory reserved',
    },
    line_item_invoiced_measure_label: {
        id: 'common.rich_text.merge_fields.line_item_invoiced_measure_label',
        defaultMessage: 'Sales line - Quantity invoiced',
    },
    line_item_internal_notes_label: {
        id: 'common.rich_text.merge_fields.line_item_internal_notes_label',
        defaultMessage: 'Sales line - Internal notes',
    },
    line_unit_price_after_discount_tax_exclusive_label: {
        id: 'common.rich_text.merge_fields.line_unit_price_after_discount_tax_exclusive_label',
        defaultMessage: 'Sales line - Unit price (net without tax)',
    },
    order_internal_notes_label: {
        id: 'common.rich_text.merge_fields.order_internal_notes_label',
        defaultMessage: 'Last Internal Note',
    },
    order_reference_identifier: {
        id: 'common.rich_text.merge_fields.order_reference_identifier',
        defaultMessage: 'Order Reference',
    },
    grouped_quantity_unit: {
        id: 'common.rich_text.merge_fields.grouped_quantity_unit',
        defaultMessage: 'Quantity - Total number of units',
    },
    grouped_quantity_time: {
        id: 'common.rich_text.merge_fields.grouped_quantity_time',
        defaultMessage: 'Quantity - Total time',
    }
})

class MergeFieldsSelector extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            item: this.props.value || null,
            uniqueId: uuidv4(),
            value: '{first_name}',
            editMode: false,
            onChange: this.props.onChange || function () {
            },
            onClose: this.props.onClose || function () {
            },
            className: this.props.className || '',
            customFields: {},
            allowedFields: this.props.allowedFields || [],
            pricingTableMergeFieldsOnly: this.props.pricingTableMergeFieldsOnly || false,
        }
        this.close = this.close.bind(this)
        this.save = this.save.bind(this)
        this.getProposalTypes = this.getProposalTypes.bind(this)
    }

    UNSAFE_componentWillMount() {
        AppContext.getApiClient().get('/custom-field-definitions').then(r => {
            let customFields = {}
            for (let index in r.data) {
                const def = r.data[index]
                const isCustomFieldAvailableForProposalType = ProposalMergeFields.includeDefinition(def, this.getProposalTypes(this.props.variables.proposalType))
                const isCustomFieldFromContact = ProposalMergeFields.includeDefinitionInContact(def)

                if (isCustomFieldAvailableForProposalType) {
                    const varName = ProposalMergeFields.formatCustomFieldNameToVariable(def.attributes.name, false)
                    customFields[varName] = def.attributes.name
                }

                if (isCustomFieldFromContact) {
                    const varNameContact = ProposalMergeFields.formatCustomFieldNameToVariable(def.attributes.name, true)
                    customFields[varNameContact] = "Contact " + def.attributes.name
                }

            }
            this.setState({
                customFields: customFields,
            })
        })
    }

    getProposalTypes(name) {
        return name + "s"
    }

    close(event) {
        event?.preventDefault()
        this.state.onClose()
    }

    save(event) {
        event.preventDefault()
        this.state.onChange(this.state.value)
        this.state.onClose()
    }

    getMergeFields() {
        if (!this.state.pricingTableMergeFieldsOnly) {
            let mergeFields = {
                '{first_name}': this.props.intl.formatMessage(messages.first_name_label),
                '{last_name}': this.props.intl.formatMessage(messages.last_name_label),
                '{name}': this.props.intl.formatMessage(messages.name_label),
                '{street}': this.props.intl.formatMessage(messages.street_label),
                '{city}': this.props.intl.formatMessage(messages.city_label),
                '{postal_code}': this.props.intl.formatMessage(messages.postal_code_label),
                '{country}': this.props.intl.formatMessage(messages.country_label),
                '{state}': this.props.intl.formatMessage(messages.state_label),
                '{total_amount}': this.props.intl.formatMessage(messages.total_amount_label),
                '{total_amount_without_tax}': this.props.intl.formatMessage(messages.total_amount_without_tax_label),
                '{project_title}': this.props.intl.formatMessage(messages.project_title_label),
                '{deposit_amount}': this.props.intl.formatMessage(messages.deposit_amount_label),
                '{deposit_ratio}': this.props.intl.formatMessage(messages.deposit_ratio_label),
                '{remaining_balance}': this.props.intl.formatMessage(messages.remaining_balance_label),
                '{paid_amount}': this.props.intl.formatMessage(messages.paid_amount_label),
                '{state_code}': this.props.intl.formatMessage(messages.state_code_label),
                '{organization_name}': this.props.intl.formatMessage(messages.organization_name_label),
                '{email}': this.props.intl.formatMessage(messages.email_label),
                '{phone_number}': this.props.intl.formatMessage(messages.phone_number_label),
                '{grand_total_discount_amount}': this.props.intl.formatMessage(messages.grand_total_discount_amount_label),
                '{grand_total_discount_ratio}': this.props.intl.formatMessage(messages.grand_total_discount_ratio_label),
                '{discount_amount}': this.props.intl.formatMessage(messages.discount_amount_label),
                '{discount_percent}': this.props.intl.formatMessage(messages.discount_percent_label),
                '{due_date}': this.props.intl.formatMessage(messages.due_date_label),
                '{captured_at}': this.props.intl.formatMessage(messages.captured_at_label),
                '{date}': this.props.intl.formatMessage(messages.date_label),
                '{lightspeed_external_id}': this.props.intl.formatMessage(messages.lightspeed_external_id_label),
                '{lightspeed_workorder_id}': this.props.intl.formatMessage(messages.lightspeed_workorder_id_label),
                '{reference}': this.props.intl.formatMessage(messages.reference_label),
                '{pdf_url}': this.props.intl.formatMessage(messages.pdf_url_label),
                '{ship_to_first_name}': this.props.intl.formatMessage(messages.ship_to_first_name_label),
                '{ship_to_last_name}': this.props.intl.formatMessage(messages.ship_to_last_name_label),
                '{ship_to_name}': this.props.intl.formatMessage(messages.ship_to_name_label),
                '{ship_to_street}': this.props.intl.formatMessage(messages.ship_to_street_label),
                '{ship_to_city}': this.props.intl.formatMessage(messages.ship_to_city_label),
                '{ship_to_postal_code}': this.props.intl.formatMessage(messages.ship_to_postal_code_label),
                '{ship_to_country}': this.props.intl.formatMessage(messages.ship_to_country_label),
                '{ship_to_state}': this.props.intl.formatMessage(messages.ship_to_state_label),
                '{ship_to_state_code}': this.props.intl.formatMessage(messages.ship_to_state_code_label),
                '{ship_to_organization_name}': this.props.intl.formatMessage(messages.ship_to_organization_name_label),
                '{ship_to_phone_number}': this.props.intl.formatMessage(messages.ship_to_phone_number_label),
                '{seller_name}': this.props.intl.formatMessage(messages.seller_name_label),
                '{seller_email}': this.props.intl.formatMessage(messages.seller_email_label),
                '{company_name}': this.props.intl.formatMessage(messages.company_name_label),
                '{company_phone_number}': this.props.intl.formatMessage(messages.company_phone_number_label),
                '{company_email}': this.props.intl.formatMessage(messages.company_email_label),
                '{company_street}': this.props.intl.formatMessage(messages.company_street_label),
                '{company_city}': this.props.intl.formatMessage(messages.company_city_label),
                '{company_state}': this.props.intl.formatMessage(messages.company_state_label),
                '{company_state_code}': this.props.intl.formatMessage(messages.company_state_code_label),
                '{company_country}': this.props.intl.formatMessage(messages.company_country_label),
                '{company_postal_code}': this.props.intl.formatMessage(messages.company_postal_code_label),
                '{po_number}': this.props.intl.formatMessage(messages.po_number_label),
                '{identifier}': this.props.intl.formatMessage(messages.document_identifier_label),
                '{expiration_date}': this.props.intl.formatMessage(messages.quote_expiration_date_label),
                '{last_internal_note}': this.props.intl.formatMessage(messages.order_internal_notes_label),
                '{contact_tax_number}': this.props.intl.formatMessage(messages.contact_tax_number),
                '{account_tax_number}': this.props.intl.formatMessage(messages.account_tax_number),
                '{order_reference}': this.props.intl.formatMessage(messages.order_reference_identifier),
                '{grouped_quantity_unit}': this.props.intl.formatMessage(messages.grouped_quantity_unit),
                '{grouped_quantity_time}': this.props.intl.formatMessage(messages.grouped_quantity_time),
            }
            for (let index in this.state.customFields) {
                mergeFields[index] = this.state.customFields[index]
            }
            return mergeFields
        }

        return {
            '{line_tax_amount}': this.props.intl.formatMessage(messages.line_tax_amount_label),
            '{line_subtotal_amount}': this.props.intl.formatMessage(messages.line_subtotal_amount_label),
            '{line_subtotal_inclusive_amount}': this.props.intl.formatMessage(messages.line_subtotal_inclusive_amount_label),
            '{line_subtotal_amount_with_discount}': this.props.intl.formatMessage(messages.line_subtotal_amount_with_discount_label),
            '{line_subtotal_amount_with_global_discount}': this.props.intl.formatMessage(messages.line_subtotal_amount_with_global_discount_label),
            '{line_total_amount}': this.props.intl.formatMessage(messages.line_total_amount_label),
            '{line_total_discount_amount}': this.props.intl.formatMessage(messages.line_total_discount_amount_label),
            '{line_total_discount_amount_percentage}': this.props.intl.formatMessage(messages.line_total_discount_amount_percentage_label),
            '{line_unit_price}': this.props.intl.formatMessage(messages.line_unit_price_label),
            '{line_unit_price_after_discount}': this.props.intl.formatMessage(messages.line_unit_price_after_discount_label),
            '{line_unit_price_inclusive}': this.props.intl.formatMessage(messages.line_unit_price_inclusive_label),
            '{line_unit_price_after_discount_tax_exclusive}': this.props.intl.formatMessage(messages.line_unit_price_after_discount_tax_exclusive_label),
            '{line_item_title}': this.props.intl.formatMessage(messages.line_item_title_label),
            '{line_item_measure}': this.props.intl.formatMessage(messages.line_item_measure_label),
            '{line_item_sku}': this.props.intl.formatMessage(messages.line_item_sku_label),
            '{line_item_manufacturer_sku}': this.props.intl.formatMessage(messages.line_item_manufacturer_sku_label),
            '{line_item_manufacturers}': this.props.intl.formatMessage(messages.line_item_manufacturers_label),
            '{line_item_short_description}': this.props.intl.formatMessage(messages.line_item_short_description_label),
            '{line_item_long_description}': this.props.intl.formatMessage(messages.line_item_long_description_label),
            '{line_item_tax_name}': this.props.intl.formatMessage(messages.line_item_tax_name_label),
            '{line_item_total_tax_rate}': this.props.intl.formatMessage(messages.line_item_total_tax_rate_label),
            '{line_item_inventory_requested}': this.props.intl.formatMessage(messages.line_item_inventory_requested_label),
            '{line_item_inventory_received}': this.props.intl.formatMessage(messages.line_item_inventory_received_label),
            '{line_item_inventory_reserved}': this.props.intl.formatMessage(messages.line_item_inventory_reserved_label),
            '{line_item_invoiced_measure}': this.props.intl.formatMessage(messages.line_item_invoiced_measure_label),
            '{line_item_internal_notes}': this.props.intl.formatMessage(messages.line_item_internal_notes_label),
        }
    }

    getMergeFieldsLabel() {
        const mergeFields = this.getMergeFields()
        if (this.state.allowedFields.length > 0) {
            const fields = {}
            for (let index in this.state.allowedFields) {
                const field = '{' + this.state.allowedFields[index] + '}'
                if (mergeFields[field]) {
                    fields[field] = mergeFields[field]
                }
            }
            return fields
        }
        return mergeFields
    }

    render() {
        const fields = this.getMergeFieldsLabel()
        const keys = Object.keys(fields)
        const data = keys.map(k => {
            return {
                value: k,
                label: fields[k],
            }
        }).sort(function (a, b) {
            if (a.label < b.label) {
                return -1;
            }
            if (a.label > b.label) {
                return 1;
            }
            return 0;
        })
        return <div className={"dropdown-menu p-4 show w-100 mt-0"} style={{
            position: 'relative',
            borderTop: 0,
            borderRadius: 0,
        }}>
            <p className="m-0 pt-2">
                <Select
                    clearable={false}
                    value={data.filter(o => o.value === this.state.value)[0]}
                    onChange={opt => {
                        this.setState({ value: opt.value })
                    }}
                    options={data}
                />
            </p>
            <p className="m-0 pt-2">
                <button className="btn btn-sm btn-outline-secondary" onClick={this.close}>
                    <Icon value={"arrow-left"} />
                </button>
                <button className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                    <Icon value={"check"} />
                </button>
            </p>
        </div>
    }

}

export default injectIntl(MergeFieldsSelector)





// WEBPACK FOOTER //
// ./src/common/rich-text/mergefields.component.jsx